import classNames from "classnames";
import { Fragment, useState } from "react";
import { MiniButton } from "./conditions-buttons";
import { ConditionsCondition } from "./conditions-condition";

export function ConditionsGroup({
  data,
  condition,
  path,
  update,
  errors,
  defaultSuggestion,
  editing,
}) {
  const definitionGroups = {
    Conditions: [],
    Special: [{ value: "group", label: "Condition Group" }],
  };

  Object.entries(data.definitions).forEach(([key, value]) => {
    const group = value.group ?? "Conditions";
    if (!definitionGroups[group]) {
      definitionGroups[group] = [];
    }
    definitionGroups[group].push({ value: key, label: value.title });
  });

  const sortedDefinitions = Object.entries(definitionGroups)
    .sort(([a], [b]) => {
      return a.localeCompare(b);
    })
    .map(([k, v]) => ({
      label: k,
      options: v.sort((a, b) => a.label.localeCompare(b.label)),
    }));

  const [currentAddOption, setCurrentAddOption] = useState(
    defaultSuggestion ?? sortedDefinitions[0].options[0].value
  );

  const opposite = condition.data.mode === "AND" ? "OR" : "AND";

  return (
    <div className="w-full border border-primaryHover rounded border-l-8 overflow-hidden">
      {editing && (
        <div className="p-2 bg-primary flex gap-2 text-xs font-bold text-white uppercase items-center">
          <div>{condition.data.mode} Group</div>
          <MiniButton
            color="primary-light"
            onClick={(e) => {
              e.preventDefault();
              update(
                {
                  action: "edit",
                  key: "mode",
                  value: opposite,
                },
                path
              );
              return false;
            }}
          >
            Switch to {opposite}
          </MiniButton>
        </div>
      )}
      {!editing && condition.data.children.length < 1 ? (
        <div className="p-3">Empty group</div>
      ) : (
        condition.data.children.map((c, i) => (
          <Fragment key={i}>
            {i !== 0 && (
              <div
                className={classNames(
                  "font-bold mx-2",
                  editing ? "text-left" : "text-center"
                )}
              >
                {condition.data.mode}
              </div>
            )}
            <ConditionsCondition
              data={data}
              condition={c}
              update={update}
              idx={i}
              path={path}
              errors={errors}
              defaultSuggestion={defaultSuggestion}
              editing={editing}
            />
          </Fragment>
        ))
      )}
      {editing && (
        <div className="p-2 bg-primary flex gap-2 text-sm">
          <select
            name="type"
            className="block !p-2 bg-white rounded w-full leading-none !border !border-tabBorder"
            value={currentAddOption}
            onChange={(e) => setCurrentAddOption(e.currentTarget.value)}
          >
            {sortedDefinitions.map(({ label, options }) => (
              <optgroup key={label} label={label}>
                {options.map(({ value, label }) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
          <button
            className="rounded p-2 px-4 bg-primaryHover text-white font-bold leading-none transition-colors border border-primaryHover hover:border-white"
            onClick={(e) => {
              e.preventDefault();
              update(
                {
                  action: "add",
                  type: currentAddOption,
                },
                path
              );
              return false;
            }}
          >
            Add
          </button>
        </div>
      )}
    </div>
  );
}
